import {createContext} from 'react'

import {FieldsConfiguration} from '../fields/types'

export const ConfigurationContext = createContext<FieldsConfiguration | undefined>(undefined)
